import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatIcon} from '@angular/material/icon';
import {MatButton, MatIconButton} from '@angular/material/button';
import {AssetStateService} from '../../assets/asset.state.service';
import {max, Subscription} from 'rxjs';
import {AssetCount} from '../../assets/asset-count';
import {AssetAction} from './asset-action';
import {TranslatePipe} from '@ngx-translate/core';
import {UploadStateService} from "../../upload/upload-state.service";
import {FilterStateService} from '../filter-state.service';
import {Collection, ReadonlyCollection} from "../../collection/collection.model";
import {CollectionService} from "../../collection/collection.service";
import {AddToCollectionComponent} from "../../add-to-collection/add-to-collection.component";
import {MatDialog} from "@angular/material/dialog";
import {ConfirmComponent} from "../../common/confirme/confirm.component";
import {ConfirmData} from "../../common/confirm-data";
import {MatTooltip} from "@angular/material/tooltip";
import {SnackBarService} from "../../common/snack-bar-service";
import {User} from "../../user/user";
import {UserStateService} from "../../user/user.state.service";

@Component({
    selector: 'app-action-bar',
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        MatIcon,
        MatIconButton,
        TranslatePipe,
        MatTooltip,
        MatButton
    ],
    templateUrl: './action-bar.component.html',
    styleUrl: './action-bar.component.scss'
})


export class ActionBarComponent implements OnInit, OnDestroy {
    assetCountSubscription: Subscription | undefined;
    assetCount: AssetCount | undefined;
    userSubscription: Subscription |undefined;
    collectionSubscription: Subscription | undefined;
    showBarSubscription: Subscription | undefined;
    showBar: boolean = false
    collection: Collection | null = null;
    readOnlyCollection: ReadonlyCollection | null = null;
    readOnlySubscription: Subscription | null = null;
    user: User | undefined;
    maxDownloads: number = 50;

    constructor(
        private dialog: MatDialog,
        private assetStateService: AssetStateService,
        private uploadStateService: UploadStateService,
        private filterStateService: FilterStateService,
        private collectionService: CollectionService,
        private snackBarService: SnackBarService,
        private userStateService: UserStateService,
    ) {
    }

    ngOnInit() {
        this.assetCountSubscription = this.assetStateService.assetCount$.subscribe((assetCount: AssetCount) => {

            this.assetCount = assetCount;
            // console.log('assetCount in actionBar', this.assetCount.assetsTotal);
        })
        this.showBarSubscription = this.filterStateService.getShowFilter().subscribe(res => {
            this.showBar = res;
        })
        this.collectionSubscription = this.assetStateService.collection$.subscribe(collection => {
            if (collection) {
                this.collection = collection;
                if (this.readOnlyCollection) {
                    this.readOnlyCollection = null;
                }
            } else {
                if (this.collection) {
                    this.collection = null;
                }
            }

        })
        this.readOnlySubscription = this.assetStateService.readonlyCollection$.subscribe(readOnlyCollection => {
            if (readOnlyCollection) {
                this.readOnlyCollection = readOnlyCollection;
                if (this.collection) {
                    this.collection = null;
                }
            } else {
                if (this.readOnlyCollection) {
                    this.readOnlyCollection = null;
                }
            }
        })
        this.userSubscription = this.userStateService.user$.subscribe(user => {
            if (user) {
                this.user = user;
            }
        })

    }

    startEdit() {
        this.uploadStateService.mode = 'edit';
    }
    clearSelectedAssets() {
        this.assetStateService.assetAction = AssetAction.selectNone;
    }

    addToCollection() {
        const assets = this.assetStateService.assetSelection;
        this.dialog.open(AddToCollectionComponent, {
            width: '600px',
            data: {
                assets
            }
        }).afterClosed().subscribe(value => {
            if (value) {
                if (value.created) {
                    this.snackBarService.showMessage({
                        message: 'collection.created.success',
                        success: true
                    })
                } else {
                    this.snackBarService.showMessage({
                        message: 'addedToCollection_success',
                        success: true
                    })
                }
            }
        });
    }

    removeFromCollection() {
        let data: ConfirmData = {
            headline: 'confirm.removeAssets',
            mess1: 'confirm.removeAssetsMessage',
            mess2: '',
            mess3: ''
        };
        let assets = this.assetStateService.assetSelection;
        let ref = this.dialog.open(ConfirmComponent, {
            data
        })
        ref.afterClosed().subscribe(res => {
            if (res) {
                this.collectionService.removeAssetFromCollection(this.collection!.uuid, assets.map(a => a.uuid))
                    .subscribe(() => {
                        this.assetStateService.assetSelection = [];
                        this.assetStateService.clearFilter();
                        this.snackBarService.showMessage({
                            message: 'action.removefromcollection.success',
                            success: true
                        });
                    });
            }
        });
    }
    deleteAssets() {
        this.assetStateService.assetAction = AssetAction.deleteAssets;
    }

    shareAssets() {
        const assets = this.assetStateService.assetSelection;
        this.dialog.open(AddToCollectionComponent, {
            width: '600px',
            data: {
                assets,
                initNew: true
            }
        }).afterClosed().subscribe(value => {
            if (value) {
                if (value.created) {
                    this.snackBarService.showMessage({
                        message: 'collection.created.success',
                        success: true
                    })
                } else {
                    this.snackBarService.showMessage({
                        message: 'action.addtocollection.success',
                        success: true
                    })
                }
            }

        });
    }
    downloadAssets() {
        if (this.assetCount && this.assetCount.assetsSelected <= this.maxDownloads) {
            this.assetStateService.assetAction = AssetAction.downloadAssets;
        } else {
            this.snackBarService.showMessage({
                message: 'download.limit.exceeded',
                success: false
            })
        }
    }
    downloadAllAssets() {
        if (this.assetCount && this.assetCount.assetsTotal <= this.maxDownloads) {
            this.assetStateService.assetAction = AssetAction.downloadAllAssets;
        } else {
            this.snackBarService.showMessage({
                message: 'download.limit.exceeded',
                success: false
            })
        }
    }

    ngOnDestroy() {
        if (this.assetCountSubscription) {
            this.assetCountSubscription.unsubscribe();
        }
        if (this.showBarSubscription) {
            this.showBarSubscription.unsubscribe();
        }
        if (this.collectionSubscription) {
            this.collectionSubscription.unsubscribe();
        }
        if (this.userSubscription) {
            this.userSubscription.unsubscribe()
        }
    }

    protected readonly AssetAction = AssetAction;
    protected readonly max = max;
}
